<div class="example_outer_section">
    <div class="example_top_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1>Trinka Offers All-Round Writing Enhancement</h1>
                    <p>Designed to help academics and technical writers, Trinka checks your writing not just for grammar but also for advanced writing needs that are critical to effective communication.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Advanced English grammar checker to improve your writing quality</h2>
                    <p>Academic and technical writing present peculiar writing errors that other tools don’t catch. Trinka comes to your rescue!</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Subject-verb disagreement</h3>
                        <p>Therefore, these results suggest that the hypersecretion of CRH and endorphin
                            <del>suppress</del>
                            <span class="right_word">suppresses</span> the secretion of LH and FSH from the pituitary gland.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Word choice</h3>
                        <p>The statistical analyses were performed <del>with</del> <span class="right_word">using</span> a statistical analysis software (SAS).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Preposition</h3>
                        <p>Recent years have seen an increase <del>of</del> <span class="right_word">in</span> exudation of various organic acids.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Adjective use</h3>
                        <p>The group receiving the placebo treatment had the <del>most</del> highest improvement in sleep scores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="exapmle_cards_heading background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Enhancements for publication-standard writing</h2>
                    <p>With checks that enhance tone, style, and adherence to standard style guides, Trinka helps you make your writing fit for the academic audience.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Conciseness</h3>
                        <p>Utilities would continue to <del>have the obligation</del> <span class="right_word">be
                                obliged</span> to serve retail customers.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Formal tone</h3>
                        <p>The <del>average</del> <span class="right_word">mean</span> age of the study group was 54.2 years (range: 8-90 years).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Word choice</h3>
                        <p>The assembly <del>abrogated</del> <span class="right_word">arrogated</span> to itself the right to make changes.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Style guide</h3>
                        <p>Substance <del>abuse</del> <span class="right_word">use disorder</span> has been a major public health concern.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Subject-specific checks for precise corrections</h2>
                    <p>Trinka knows that every subject area has a unique expression. It ensures that corrections do not tamper with the style specific to your subject area.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Computer science</h3>
                        <p>In our study, 90% of the users expressed the need for a <del>dialogue</del> <span class="right_word">dialog</span> box to alert them to a pending update.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Physics</h3>
                        <p>By contrast, the <del>effect</del> <span class="right_word">effects</span> of the Mach number and <span class="">heat</span> specific <span class="right_word">heat</span> ratio contribute little to the aerodynamic performance.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Medicine</h3>
                        <p>Our study matched for age, <del>gender</del> <span class="right_word">sex</span>, ethnicity, and BMI, marijuana use was associated with higher abdominal visceral fat.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h3>Economics</h3>
                        <p>The estimated natural rate, based on the <del>past</del> history of the data, plummets by nearly 2
                            <del>percent</del> <span class="right_word">percentage</span> points.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>